import { PageHeader } from 'antd';
import styled from 'styled-components';

const PageHeaderStyled = styled(PageHeader)`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;

  .ant-page-header-content {
    width: 100%;
    flex: 1;
  }

  @media(max-width: 768px) {
    span[class*=extra] {
      .ant-btn-group {
        button {
          span ~ span {
            display: none;
          }
        }
      }
    }
  }

  @media(max-width: 576px) {
    span[class*=extra] {
      display: unset;
      float: right;
      width: unset;
    }
  }
`;

export default PageHeaderStyled;
